import React from 'react';
import { Badge } from '@lightspeed/flame/Badge';

const VendorReturnStatus = ({ status, ...rest }) => {
  let params;

  switch (status) {
    case 'done': {
      params = { bg: 'gray-200' };
      break;
    }
    case 'sent': {
      params = { bg: 'orange-400', color: 'night-300' };
      break;
    }
    case 'received': {
      params = { bg: 'gray-100', color: 'night-300' };
      break;
    }
    case 'open':
    default: {
      params = { bg: 'gray-100', color: 'night-300' };
    }
  }

  return (
    <Badge {...rest} {...params}>
      {status === 'done' ? 'closed' : status}
    </Badge>
  );
};

export default VendorReturnStatus;
